import { render } from "./TogglePopover.vue?vue&type=template&id=4623fc3a&scoped=true"
import script from "./TogglePopover.vue?vue&type=script&lang=ts"
export * from "./TogglePopover.vue?vue&type=script&lang=ts"

import "./TogglePopover.vue?vue&type=style&index=0&id=4623fc3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4623fc3a"

export default script